import React from 'react';
import ColumnCell from 'main/components/show/grid/columnHeaderCell/utilityColumnCell.jsx';
import ColumnMenuHelper from 'main/components/show/grid/columnHeaderCell/columnMenuHelper';
import CuesheetColumnActions from 'flux/actions/cuesheet/CuesheetColumnActions';

import role from 'shared/lib/role';

/**
 * Item column header cell
 *
 */
export default React.createClass({
  displayName: 'GridItemColumnHeaderCell',

  propTypes: {
    title: React.PropTypes.string.isRequired,
    id: React.PropTypes.string.isRequired,
    currentWidth: React.PropTypes.string.isRequired,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    return (
      <ColumnCell {...this.props} additionalItems={this._getWidthItems()} />
    );
  },

  _getWidthItems() {
    let { teamId, eventId } = this.context.router.state.params;
    let hasEventAdmin = role.hasEventAdminRole(
      this.props.user,
      teamId,
      eventId,
    );

    return ColumnMenuHelper.getWidthColumnOptions(
      hasEventAdmin,
      this.props.currentWidth,
      (width) => CuesheetColumnActions.updateItemTitleColumnWidth(width),
    );
  },
});
